// Keep this identity and legacy fallback aligned with PublicTicketRepository.
export const getSeatCapacityDocumentId = (eventId, venueId, date, time) =>
    encodeURIComponent(`${eventId}|${venueId}|${date}|${time}|paid`).replace(/%/g, '_');

const count = value => {
    const number = value === undefined ? 0 : value;
    if (!Number.isSafeInteger(number) || number < 0) {
        throw new Error('Invalid ticket capacity count.');
    }
    return number;
};

export const getLayoutCapacityRows = ({ venue, capacity, bookings = [] }) => {
    const capacityByTier = (venue.seatConfig || []).reduce((counts, config) => {
        const tier = String(config.areaType || '').toLowerCase();
        if (tier) counts[tier] = count(counts[tier]) + count(Number(config.seatCount || 0));
        return counts;
    }, {});

    // All purchased quantities consume capacity, even without selected/assigned chairs.
    // Never infer release from a local expiry time or a physically available seat.
    const reservedByTier = capacity ? capacity.reservedByTier || {} : bookings
        .filter(booking => !booking.isMasterclass && (
            ['pending', 'PAID', 'paid'].includes(booking.paymentStatus)
            || (booking.paymentStatus === 'failed' && booking.checkoutFailure?.cleanupStatus !== 'complete')
        ))
        .reduce((counts, booking) => {
            (booking.tickets || []).forEach(ticket => {
                const tier = String(ticket.id || '').toLowerCase();
                counts[tier] = count(counts[tier]) + count(Number(ticket.quantity || 0));
            });
            return counts;
        }, {});

    return ['presto', 'allegro'].map(tier => {
        const total = count(capacityByTier[tier]);
        const reserved = count(reservedByTier[tier]);
        const blocked = count(capacity?.blockedByTier?.[tier]);
        const remaining = total - reserved - blocked;
        return { tier, total, reserved, blocked, available: Math.max(0, remaining), overCapacity: Math.max(0, -remaining) };
    });
};
